import { Icon } from '@iconify/react';
import archiveOutline from '@iconify/icons-eva/archive-outline';
import folderOpenTwotone from '@iconify/icons-ant-design/folder-open-twotone';
import dashboardOutlined from '@iconify/icons-ant-design/dashboard-outlined';
import people24Regular from '@iconify/icons-fluent/people-24-regular';
import settings24Regular from '@iconify/icons-fluent/settings-24-regular';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const getSidebarConfig = (role) => {
  return [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: getIcon(dashboardOutlined),
      notAllowedRoles: ['DOCTOR']
    },
    {
      title: 'all requests',
      path:
        role === 'ADMIN'
          ? '/dashboard/all-requests?filterColumn=status&filterOperation=isAnyOf&filterValue=PENDING_ADMIN_REVIEW&sortColumn=createdAt&sort=desc'
          : '/dashboard/all-requests',
      icon: getIcon(folderOpenTwotone),
      notAllowedRoles: ['EMPLOYEE']
    },
    {
      title: 'my requests',
      path: '/dashboard/requests',
      icon: getIcon(archiveOutline),
      notAllowedRoles: ['DOCTOR']
    },
    {
      title: 'employees',
      path: '/dashboard/employees',
      icon: getIcon(people24Regular),
      allowedRoles: ['ADMIN']
    },
    {
      title: 'configurations',
      path: '/dashboard/config',
      icon: getIcon(settings24Regular),
      allowedRoles: ['ADMIN', 'FINANCE'],
      managedByExternalAdmin: false
    }
  ];
};

export default getSidebarConfig;
